import { render, staticRenderFns } from "./ExportMaterial.vue?vue&type=template&id=2ec33b96"
import script from "./ExportMaterial.vue?vue&type=script&lang=js"
export * from "./ExportMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports